import { SavedListCreatorType, SavedListType } from 'ui-components';
import { mapCreatorFromApiModelToViewModel } from '~/clientApi';
import { Creator } from '~/clientApi/creator.model';
import { SavedList } from '~/clientApi/savedLists.model';
import { getMainPlatformData } from '~/core/utils';
import { ICreator } from '~/types';

export const mapCreatorFromFoamToUI = (
  creator: ICreator,
): SavedListCreatorType => {
  const { avatar = '', email, handle, name } = getMainPlatformData(creator);
  const searchable: string[] = [];

  if (email) {
    searchable.push(email); // this enables users to be able to search by email
  }

  if (creator.platforms) {
    Object.entries(creator.platforms).forEach(([_, { handle }]) => {
      if (handle) {
        searchable.push(handle); // this enables users to be able to search by any platform handle
      }
    });
  }

  return {
    avatar,
    id: creator.id,
    name: name ?? handle ?? email ?? '',
    note: '', // Clear to avoid dragging into new lists
    searchable,
  };
};

export const mapCreatorFromApiToUI = (
  creator: Creator,
): SavedListCreatorType => {
  const foamCreator = mapCreatorFromApiModelToViewModel(creator);
  return mapCreatorFromFoamToUI(foamCreator);
};

export const mapSavedListFromFoamToUI = (
  lists: SavedList[],
  isAgencyListEnabled: boolean = false,
): SavedListType[] =>
  lists
    .filter(({ category }) => category === 'list')
    .map(
      ({
        agencyName,
        createdAt,
        firstFourCreators: firstFourCreator,
        id,
        manager,
        name,
        totalCreators: totalCreator,
        listOrderAgency,
        listOrder,
      }) => ({
        createdAt,
        firstFourCreator: firstFourCreator.map(mapCreatorFromApiToUI),
        id,
        name,
        ownerName: manager?.name ?? agencyName,
        totalCreator,
        order: isAgencyListEnabled
          ? listOrderAgency ?? undefined
          : listOrder ?? undefined,
      }),
    );
